// PROTOTYPE
import * as React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $createParagraphNode,
  $insertNodes,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
} from 'lexical';
import { $createVideoNode, type VideoPayload } from '../nodes/VideoNode';

export const INSERT_VIDEO_COMMAND = createCommand<VideoPayload>();

export function VideosPlugin() {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    return editor.registerCommand(
      INSERT_VIDEO_COMMAND,
      (payload) => {
        editor.update(() => {
          const videoNode = $createVideoNode(payload);

          $insertNodes([videoNode]);

          // Block decorator: leave a paragraph after it so the author can keep typing.
          if (!videoNode.getNextSibling()) {
            const paragraph = $createParagraphNode();
            videoNode.insertAfter(paragraph);
            paragraph.selectStart();
          }
        });

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
